module.exports = __webpack_public_path__ + "7f383aabca63ae63a367753d74d06abf.MP3";